import React, { useState, useEffect } from "react";
import { Alert, Badge, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import CommentItem from "../../../../UI/shared/recentComments/CommentItem";
import {
  ApprovalBadge,
  isActivityFree,
} from "../../../../../helpers/CommonHelper";

const ActivityRecentRegistrations = ({ activityId, limit, data }) => {
  const [state, setState] = useState({
    isLoading: true,
    status: "fetching", //fetching, fetched, fetchFailed
    error: "",
    data: {},
  });

  const loadData = async () => {
    try {
      const res = await axios.get(
        `activity-registrations/${activityId}?limit=5`,
      ); //
      //console.log(res);
      setState({
        isLoading: false,
        status: "fetched", //fetching, fetched, fetchFailed
        error: "",
        data: res.data,
      });
    } catch (error) {
      setState({
        isLoading: false,
        status: "fetchFailed", //fetching, fetched, fetchFailed
        error: error,
        data: {},
      });
    }
  };

  useEffect(() => {
    if (activityId) {
      loadData();
    }
  }, [activityId]);

  const showPartnerGroup =
    state.data.activity && state.data.activity.partnerAllowed === "1";
  const showGuestGroup =
    state.data.activity && state.data.activity.guestAllowed === "1";
  const showKidsGroup =
    state.data.activity && state.data.activity.kidsAllowed === "1";

  return (
    <div className="activity-recent-registrations">
      <Card className="card-primary mb-0">
        <Card.Header className="cardHead">
          <Card.Title>
            Recent Registration(s){" "}
            {state.data.pagination && state.data.pagination.totalItems
              ? "- Total " + state.data.pagination.totalItems + " item(s)"
              : null}
          </Card.Title>

          <div class="card-tools mt-0">
            <Button
              variant="primary"
              size="xs"
              href={`/activity-registrations/${activityId}`}
            >
              View More
            </Button>
          </div>
        </Card.Header>
        <Card.Body className="m-0 p-0">
          {state.status === "fetchFailed" && state.error ? (
            <Alert variant="danger" className="m-0">
              <b>Error!</b> Fetching items failed.
            </Alert>
          ) : (
            <>
              {!state.data.items || state.data.items.length <= 0 ? (
                <Alert variant="warning" className="m-0">
                  No items found .
                </Alert>
              ) : (
                <>
                  <div className="registrationTable ">
                    <style>{`
                      .registrationTable table,
                      .registrationTable th,
                      .registrationTable td {
                        border: 1px solid #c7c9cc;
                      }

                      .registrationTable thead th {
                        padding: 8px 10px;
                        vertical-align: middle;
                        line-height: 1.3;
                        white-space: nowrap;
                      }

                      .registrationTable thead tr:first-child th {
                        font-size: 12px;
                        font-weight: 600;
                        letter-spacing: 0.02em;
                        text-transform: uppercase;
                      }

                      .registrationTable thead tr:last-child th {
                        font-size: 12px;
                        font-weight: 400;
                        color: #5f6368;
                        text-transform: none;
                        padding-top: 6px;
                        padding-bottom: 6px;
                      }

                      .registrationTable thead th[rowspan="2"] {
                        font-size: 13px;
                        font-weight: 600;
                        text-transform: none;
                        letter-spacing: normal;
                      }

                      .registrationTable table {
                        position: relative;
                      }
                      .registrationTable thead th {
                        position: sticky;
                        top: 0;
                        z-index: 1;
                      }

                      .regCol-member { background: #E6F1FB; color: #0C447C; }
                      .regCol-partner { background: #D6F3EA; color: #085041; }
                      .regCol-guest { background: #FBEAF0; color: #4B1528; }
                      .regCol-kids { background: #EEEDFE; color: #26215C; }

                      tbody .regCol-member,
                      tbody .regCol-partner,
                      tbody .regCol-guest,
                      tbody .regCol-kids {
                        background: transparent;
                        color: inherit;
                      }

                      .registrationTable td {
                        min-height: 20px;
                        vertical-align: middle;
                      }

                      .registrationTable tbody tr {
                        background-color: rgba(22, 157, 87, 0.1);
                        --bs-table-accent-bg: none;
                      }

                      .bg-table {
                        background-color: rgba(59, 160, 81, 0.3) !important;
                        --bs-table-accent-bg: none;
                      }
                    `}</style>
                    <Table bordered size="sm" className="m-0 p-0">
                      <thead>
                        <tr>
                          <th rowSpan={2} className="regCol-member">
                            #
                          </th>
                          <th rowSpan={2} className="regCol-member">
                            Member Name
                          </th>
                          <th rowSpan={2} className="text-center regCol-member">
                            Member Status
                          </th>

                          {showPartnerGroup && (
                            <th
                              colSpan={2}
                              className="text-center regCol-partner"
                            >
                              Partner
                            </th>
                          )}
                          {showGuestGroup && (
                            <th
                              colSpan={
                                data?.guestFeaturesSettings
                                  ?.requireAdminApproval === "1"
                                  ? 3
                                  : 2
                              }
                              className="text-center regCol-guest"
                            >
                              Guest
                            </th>
                          )}
                          {showKidsGroup && (
                            <th
                              colSpan={
                                data?.kidsFeaturesSettings
                                  ?.requireAdminApproval === "1"
                                  ? 3
                                  : 2
                              }
                              className="text-center regCol-kids"
                            >
                              Kids
                            </th>
                          )}

                          <th rowSpan={2} className="text-center">
                            Registration Time
                          </th>
                        </tr>
                        <tr>
                          {showPartnerGroup && (
                            <>
                              <th className="text-center regCol-partner">
                                Participating
                              </th>

                              <th className="text-center regCol-partner">
                                Status
                              </th>
                            </>
                          )}
                          {showGuestGroup && (
                            <>
                              <th className="text-center regCol-guest">
                                Participating
                              </th>
                              {data?.guestFeaturesSettings
                                ?.requireAdminApproval === "1" && (
                                <th className="text-center regCol-guest">
                                  Admin Approval
                                </th>
                              )}
                              <th className="text-center regCol-guest">
                                Status
                              </th>
                            </>
                          )}
                          {showKidsGroup && (
                            <>
                              <th className="text-center regCol-kids">
                                Participating
                              </th>
                              {data?.kidsFeaturesSettings
                                ?.requireAdminApproval === "1" && (
                                <th className="text-center regCol-guest">
                                  Admin Approval
                                </th>
                              )}
                              <th className="text-center regCol-kids">
                                Status
                              </th>
                            </>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          state.data.items.map((item, index) => {
                            return (
                              <>
                                <tr
                                  index={index}
                                  className={
                                    item.additionalRequests &&
                                    item.additionalRequests.length <= 0 &&
                                    "borderBottom"
                                  }
                                >
                                  <td
                                    rowSpan={
                                      item.additionalRequests &&
                                      item.additionalRequests.length > 0 &&
                                      item.additionalRequests.length + 1
                                    }
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    rowSpan={
                                      item.additionalRequests &&
                                      item.additionalRequests.length > 0 &&
                                      item.additionalRequests.length + 1
                                    }
                                  >
                                    <Button
                                      href={`/members/${item.memberId}`}
                                      variant="link"
                                    >
                                      {item.member.fullName
                                        ? item.member.fullName
                                        : "-"}
                                    </Button>
                                  </td>

                                  <td className="text-center">
                                    {item.memberStatus === "1" ? (
                                      <Badge bg="success">Confirmed</Badge>
                                    ) : item.memberStatus === "0" ? (
                                      <Badge bg="warning" text="dark">
                                        Payment Pending
                                      </Badge>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  {/* Partner group */}
                                  {showPartnerGroup && (
                                    <>
                                      <td className="text-center">
                                        <>
                                          {item.partnerParticipating === "1" ? (
                                            <Badge bg="success">Yes</Badge>
                                          ) : (
                                            "-"
                                          )}
                                        </>
                                      </td>
                                      <td className="text-center">
                                        {item.partnerStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : item.partnerParticipating === "1" &&
                                          item.payment
                                            ?.partnerParticipationFee > 0 ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : item.partnerParticipating ===
                                          "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </>
                                  )}

                                  {/* Guest group */}
                                  {showGuestGroup && (
                                    <>
                                      <td className="text-center">
                                        <>
                                          {item.guestParticipating === "1" ? (
                                            <Badge bg="success">
                                              Yes (
                                              {item.NumberOfGuestParticipating})
                                            </Badge>
                                          ) : (
                                            "-"
                                          )}
                                        </>
                                      </td>
                                      {data?.guestFeaturesSettings
                                        ?.requireAdminApproval === "1" && (
                                        <td className="text-center">
                                          <ApprovalBadge
                                            status={item?.guestApprovalStatus}
                                          />
                                        </td>
                                      )}
                                      <td className="text-center">
                                        {item.guestStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : item.guestParticipating === "1" &&
                                          item?.payment?.guestParticipationFee >
                                            0 ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : item.guestParticipating === "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </>
                                  )}

                                  {showKidsGroup && (
                                    <>
                                      <td className="text-center">
                                        <>
                                          {item.kidsParticipating === "1" ? (
                                            <Badge bg="success">
                                              Yes (
                                              {item.NumberOfKidsParticipating})
                                            </Badge>
                                          ) : (
                                            "-"
                                          )}
                                        </>
                                      </td>
                                      {data?.kidsFeaturesSettings
                                        ?.requireAdminApproval === "1" && (
                                        <td className="text-center">
                                          <ApprovalBadge
                                            status={item?.kidApprovalStatus}
                                          />
                                        </td>
                                      )}
                                      <td className="text-center">
                                        {item.kidsStatus === "1" ? (
                                          <Badge bg="success">Confirmed</Badge>
                                        ) : item.kidsParticipating === "1" &&
                                          item?.payment?.kidsParticipationFee >
                                            0 ? (
                                          <Badge bg="warning" text="dark">
                                            Payment Pending
                                          </Badge>
                                        ) : item.kidsParticipating === "1" ? (
                                          <Badge bg="warning" text="dark">
                                            Pending
                                          </Badge>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                    </>
                                  )}
                                  <td class="font-small fontItalic text-secondary fs-12 text-center">
                                    <ModuleDisplayDateTime
                                      value={item.createdAt}
                                    />
                                  </td>
                                </tr>
                                {item.additionalRequests &&
                                  item.additionalRequests.length > 0 &&
                                  item.additionalRequests.map(
                                    (request, index) => {
                                      return (
                                        <tr
                                          className={`bg-table ${
                                            index + 1 ===
                                            item.additionalRequests.length
                                              ? "borderBottom"
                                              : ""
                                          } `}
                                        >
                                          <td className="text-center">
                                            <>
                                              {request.memberStatus === "1" ? (
                                                <Badge bg="success">
                                                  Confirmed
                                                </Badge>
                                              ) : request.memberStatus ===
                                                "0" ? (
                                                <Badge bg="warning" text="dark">
                                                  Payment Pending
                                                </Badge>
                                              ) : (
                                                "-"
                                              )}
                                            </>
                                          </td>

                                          {/* Partner group */}
                                          {showPartnerGroup && (
                                            <>
                                              <td className="text-center">
                                                <>
                                                  {request.partnerParticipating ===
                                                  "1" ? (
                                                    <Badge bg="success">
                                                      Yes
                                                    </Badge>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </>
                                              </td>
                                              <td className="text-center">
                                                <>
                                                  {request.partnerStatus ===
                                                  "1" ? (
                                                    <Badge bg="success">
                                                      Confirmed
                                                    </Badge>
                                                  ) : request.partnerParticipating ===
                                                      "1" &&
                                                    request?.payment
                                                      ?.partnerParticipationFee >
                                                      0 ? (
                                                    <Badge
                                                      bg="warning"
                                                      text="dark"
                                                    >
                                                      Payment Pending
                                                    </Badge>
                                                  ) : request.partnerParticipating ===
                                                    "1" ? (
                                                    <Badge
                                                      bg="warning"
                                                      text="dark"
                                                    >
                                                      Pending
                                                    </Badge>
                                                  ) : (
                                                    "-"
                                                  )}
                                                </>
                                              </td>
                                            </>
                                          )}

                                          {/* Guest group */}
                                          {showGuestGroup && (
                                            <>
                                              <td className="text-center">
                                                <>
                                                  {request.guestParticipating ===
                                                  "1" ? (
                                                    data?.guestFeaturesSettings
                                                      ?.requireAdminApproval ===
                                                    "1" ? (
                                                      <Badge bg="success">
                                                        Yes - Requested (
                                                        {
                                                          request.reqNumberOfGuestParticipating
                                                        }
                                                        )
                                                      </Badge>
                                                    ) : (
                                                      <Badge bg="success">
                                                        Yes (
                                                        {
                                                          request.reqNumberOfGuestParticipating
                                                        }
                                                        )
                                                      </Badge>
                                                    )
                                                  ) : (
                                                    "-"
                                                  )}
                                                </>
                                              </td>

                                              {data?.guestFeaturesSettings
                                                ?.requireAdminApproval ===
                                                "1" && (
                                                <td className="text-center">
                                                  <ApprovalBadge
                                                    status={
                                                      request?.guestApprovalStatus
                                                    }
                                                    value={`${request?.guestApprovalStatus} (${request?.NumberOfGuestParticipating})`}
                                                  />
                                                </td>
                                              )}
                                              <td className="text-center">
                                                {request.guestParticipating ===
                                                  "1" &&
                                                  request.isRejected ===
                                                    "1" && (
                                                    <Badge bg="danger">
                                                      Rejected
                                                    </Badge>
                                                  )}
                                                {request.guestParticipating ===
                                                  "1" &&
                                                request.isRejected != "1" ? (
                                                  <>
                                                    {request.guestStatus ===
                                                    "1" ? (
                                                      <Badge bg="success">
                                                        Confirmed
                                                      </Badge>
                                                    ) : request.guestParticipating ===
                                                        "1" &&
                                                      request?.payment
                                                        ?.guestParticipationFee >
                                                        0 ? (
                                                      <Badge
                                                        bg="warning"
                                                        text="dark"
                                                      >
                                                        Payment Pending
                                                      </Badge>
                                                    ) : request.guestParticipating ===
                                                      "1" ? (
                                                      <Badge
                                                        bg="warning"
                                                        text="dark"
                                                      >
                                                        Pending
                                                      </Badge>
                                                    ) : (
                                                      "-"
                                                    )}
                                                  </>
                                                ) : (
                                                  "-"
                                                )}
                                              </td>
                                            </>
                                          )}

                                          {/* Kids group */}
                                          {showKidsGroup && (
                                            <>
                                              <td className="text-center">
                                                <>
                                                  {request.kidsParticipating ===
                                                  "1" ? (
                                                    data?.kidsFeaturesSettings
                                                      ?.requireAdminApproval ===
                                                    "1" ? (
                                                      <Badge bg="success">
                                                        Yes - Requested (
                                                        {
                                                          request.reqNumberOfKidsParticipating
                                                        }
                                                        )
                                                      </Badge>
                                                    ) : (
                                                      <Badge bg="success">
                                                        Yes (
                                                        {
                                                          request.reqNumberOfKidsParticipating
                                                        }
                                                        )
                                                      </Badge>
                                                    )
                                                  ) : (
                                                    "-"
                                                  )}
                                                </>
                                              </td>
                                              {data?.kidsFeaturesSettings
                                                ?.requireAdminApproval ===
                                                "1" && (
                                                <td className="text-center">
                                                  <ApprovalBadge
                                                    status={
                                                      request?.kidApprovalStatus
                                                    }
                                                    value={`${request?.kidApprovalStatus} (${request?.NumberOfKidsParticipating})`}
                                                  />
                                                </td>
                                              )}
                                              <td className="text-center">
                                                {request.kidsParticipating ===
                                                  "1" &&
                                                  request.isRejected ===
                                                    "1" && (
                                                    <Badge bg="danger">
                                                      Rejected
                                                    </Badge>
                                                  )}
                                                {request.kidsParticipating ===
                                                  "1" &&
                                                  request.isRejected != "1" && (
                                                    <>
                                                      {request.kidsStatus ===
                                                      "1" ? (
                                                        <Badge bg="success">
                                                          Confirmed
                                                        </Badge>
                                                      ) : request.kidsParticipating ===
                                                          "1" &&
                                                        request?.payment
                                                          ?.kidsParticipationFee >
                                                          0 ? (
                                                        <Badge
                                                          bg="warning"
                                                          text="dark"
                                                        >
                                                          Payment Pending
                                                        </Badge>
                                                      ) : request.kidsParticipating ===
                                                        "1" ? (
                                                        <Badge
                                                          bg="warning"
                                                          text="dark"
                                                        >
                                                          Pending
                                                        </Badge>
                                                      ) : (
                                                        "-"
                                                      )}
                                                    </>
                                                  )}
                                              </td>
                                            </>
                                          )}

                                          <td class="font-small fs-12 fontItalic  text-secondary text-center">
                                            <ModuleDisplayDateTime
                                              value={request.createdAt}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    },
                                  )}
                              </>
                            );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </>
              )}
            </>
          )}
        </Card.Body>

        {state.isLoading && (
          <div class="overlay">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
        )}
      </Card>
    </div>
  );
};

export default ActivityRecentRegistrations;
